import React, {Component} from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../../SYSTEM/Config.js'
import { sendPostRequest } from "./../../../APP/HELPERS/requests"
import { CSSTransition, TransitionGroup, CSSTransitionGroup } from 'react-transition-group';

/// REDUX ///
import * as ReduxActions from './../../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import ModalsContainer from './../../../APP/MODALS/ModalsContainer.js';

import E404 from './../../../APP/COMPONENTS/ContentParts/E404';

import FooterBlock from './../../../APP/COMPONENTS/Footer.js';

import InputMask from "react-input-mask";
import BreadCrumbs from './../../../APP/COMPONENTS/ContentParts/BreadCrumbs';

import { YMaps, Map, Polygon, Rectangle, SearchControl, Placemark } from 'react-yandex-maps';

function mapStateToProps(state, myProps) {
    return {
        TOKEN: state.TOKEN,
        DO_SEARCH: state.DO_SEARCH
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Partnership extends Component {

	constructor(props)
    {
        super(props);
        this.state = {
            TOKEN: props.TOKEN,
            NAME: '',
            PHONE: '',
            EMAIL: '',
            COMMENT: ''
        }
    }

    componentDidMount()
    {
        this.props.closeAllModals();
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.match.params.url !== prevProps.match.params.url) {
            this.props.closeAllModals();
         
            this.setState({PAGE: false, URL: this.props.match.params.url, ERROR: false});
        }
        if (this.props.TOKEN !== prevProps.TOKEN) {
            this.setState({TOKEN: this.props.TOKEN});
        }
        if (this.props.DO_SEARCH !== prevProps.DO_SEARCH) {
            if (this.props.DO_SEARCH) {
                this.props.history.push('/search/' + this.props.DO_SEARCH);
            }
        }
    }

    checkRerender()
    {
    }


    renderBreadCrumbs()
    {
        let DATA = [];
        DATA.push({
            'to' : '/',
            'title' : 'Главная'
        });

        DATA.push({
            'to' : '/company/partnership',
            'title' : 'Сотрудничество'
        });

        return <BreadCrumbs DATA={DATA} />
    }

    validatePhone = () =>
    {
        let phoneNumber = this.state.PHONE.toString().replace(/\D+/g, '');

        if (phoneNumber.length == 11) {
            return true
        } else {
            return false
        }
    }

    saveData = async () =>
    {
            let SEND_DATA = {
                action:         'recordPartnership',
                phone:          this.state.PHONE,
                name:           this.state.NAME,
                comment:        this.state.COMMENT,
                email:          this.state.EMAIL
            };

            let data = await sendPostRequest(SEND_DATA,CONFIG.API_GATE);

            if (data !== false) {
                this.setState({SAVED: true});
            }
    }

    renderSaveButton()
    {
        if (this.validatePhone()) {

            if (this.state.SAVED) {
                return <button className="orange-button"><i className="fas fa-check"></i> Заявка отправлена</button>;
            } else {
                return <button className="orange-button" onClick={() => this.saveData()}>Отправить заявку</button>;
            }

            
        } else {
            return <button className="orange-button inactive-btn">Отправить заявку</button>
        }
    }

	render() {
        return (
            <CSSTransitionGroup
                transitionAppear={true}
                transitionAppearTimeout={600}
                transitionEnterTimeout={600}
                transitionLeaveTimeout={200}
                transitionName={'SlideIn'}
            > 
                <div className="right-part">
                    <Helmet>
                        <title>Сотрудничество</title>
                        <meta name="description" content="Сотрудничество"/>
                        <meta name="keywords" content="Сотрудничество" />
                    </Helmet>

                    {this.renderBreadCrumbs()}
                    <div id="products" className="page-content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="main-heading ">Сотрудничество</h1>
                                    <div className="login_form_block form-fields">
                                    <div className="col-12 flexed-col">
                                        <span className="in-card-label">Заполните форму и мы свяжемся с вами!</span>
                                        </div>
                                        <br/><br/>
                                        <div className="col-12 flexed-col">
                                            <label>Ваше имя</label>
                                            <input
                                                type="text"
                                                label="Ваше имя"
                                                placeholder=""
                                                required="true"
                                                value={this.state.NAME}
                                                onChange={(text) => this.setState({NAME: text.target.value})}
                                                className="order-input"
                                            />
                                        </div>
                                        <div className="col-12 flexed-col">
                                            <label>Ваш email</label>
                                            <input
                                                label="Ваш email"
                                                placeholder=""
                                                required="true"
                                                type="email"
                                                value={this.state.EMAIL}
                                                onChange={(text) => this.setState({EMAIL: text.target.value})}
                                                className="order-input"
                                            />
                                        </div>
                                        <div className="col-12 flexed-col">
                                            <label>Номер телефона</label>
                                            <InputMask
                                                mask="+7-999-999-99-99"
                                                type="tel"
                                                label="Номер телефона"
                                                value={this.state.PHONE}
                                                required="true"
                                                onChange={(text) => this.setState({PHONE: text.target.value})}
                                                className="order-input"
                                            />
                                        </div>
                                        <div className="col-12 flexed-col">
                                            <label>Комментарий</label>
                                            <textarea
                                                type="text"
                                                label=""
                                                placeholder=""
                                                required="true"
                                                onChange={(text) => this.setState({COMMENT: text.target.value})}
                                                className="order-input"
                                            >{this.state.COMMENT}</textarea>
                                        </div>
                                        <div className="col-12 flexed-col">
                                        <div className="personal_column full mt">
                                            <div className="text-right">
                                                {this.renderSaveButton()}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ModalsContainer />
                </div>
   
            </CSSTransitionGroup>
        );
    }
}

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(Partnership))
